// src/pages/Home.tsx
import ConnectionStatus from "components/ConnectionStatus";
import React from "react";
import { Link } from "react-router-dom";
import { useWebSocket } from "WebSocketContext";

const Home: React.FC = () => {
  const { isConnected, playerId } = useWebSocket();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center space-y-4 text-sky-50">
      <video 
        className="absolute top-0 left-0 w-full h-full object-cover -z-10 rounded-lg" 
        autoPlay 
        loop
      >
      <source src="/Videos/WMR_24_10_21_1.mp4" type="video/mp4" />
      Your browser does not support the video tag.
      </video>
      <ConnectionStatus />
      <div className="backdrop-blur-min rounded-full p-4">
        <h1 className="text-5xl font-bold text-shadow">Welcome to Wetland Games</h1>
        <Link to="/play" className="
            text-3xl font-bold block
            text-sky-50
            mt-2
            text-shadow
            transition-all ease-in-out
            hover:rainbow-text
          ">Click Here to Play</Link>
        <Link to="/vow/play" className="
            text-3xl font-bold block
            mt-2
            text-sky-50
            text-shadow
            transition-all ease-in-out
            hover:rainbow-text
          ">VOW Commons RPG</Link>
        <Link to="/legacy" className="
            text-3xl font-bold block
            mt-2
            text-sky-50
            text-shadow
            transition-all ease-in-out
            hover:rainbow-text
          ">Legacy Prototype</Link>
        <Link to="/about" className="
            text-3xl font-bold block
            mt-2
            text-sky-50
            text-shadow
            transition-all ease-in-out
            hover:rainbow-text
          ">About</Link>
        <Link to="/credits" className="
            text-3xl font-bold block
            mt-2
            text-sky-50
            text-shadow
            transition-all ease-in-out
            hover:rainbow-text
          ">Credits</Link>
      </div>

    </div>
  );
};

export default Home;
